export function calculateRiskPlan({
  capitalChf = 10000,
  riskPercent = 1,
  entryPrice = 4700,
  stopLossPercent = 1.5,
  rewardRiskRatio = 2,
} = {}) {
  const capital = Number(capitalChf);
  const riskPct = Number(riskPercent);
  const entry = Number(entryPrice);
  const stopPct = Number(stopLossPercent);
  const rr = Number(rewardRiskRatio);

  if (![capital, riskPct, entry, stopPct, rr].every(Number.isFinite) || capital <= 0 || entry <= 0 || stopPct <= 0) {
    return {
      valid: false,
      warning: "Введите корректные значения капитала, входа и стоп-лосса.",
    };
  }

  const riskAmountChf = capital * (riskPct / 100);
  const stopLossPrice = entry * (1 - stopPct / 100);
  const riskPerOunce = entry - stopLossPrice;
  const suggestedPositionOz = riskPerOunce > 0 ? riskAmountChf / riskPerOunce : 0;
  const takeProfitPrice = entry + riskPerOunce * rr;
  const warnings = [];

  if (riskPct > 3) {
    warnings.push("Риск на сделку выше 3%; для многих инвесторов это высокий уровень.");
  }
  if (suggestedPositionOz * entry > capital * 5) {
    warnings.push("Размер позиции выглядит высоким; проверьте плечо и маржинальный риск.");
  }

  return {
    valid: true,
    riskAmountChf,
    stopLossPrice,
    takeProfitPrice,
    suggestedPositionOz,
    riskPerOunce,
    warnings,
    currencyNote: "Размер позиции является оценочным; курс CHF/USD не учитывается.",
  };
}

export function calculatePortfolio({ goldAmountOz = 0, averageBuyPrice = 0, currentPrice = 0 } = {}) {
  const amount = Number(goldAmountOz);
  const average = Number(averageBuyPrice);
  const price = Number(currentPrice);
  if (![amount, average, price].every(Number.isFinite) || amount < 0 || average < 0 || price < 0) {
    return {
      valid: false,
      warning: "Введите корректные значения портфеля.",
    };
  }

  const cost = amount * average;
  const currentValue = amount * price;
  const profitLoss = currentValue - cost;
  const profitLossPercent = cost > 0 ? (profitLoss / cost) * 100 : 0;

  return {
    valid: true,
    currentValue,
    profitLoss,
    profitLossPercent,
    breakEvenPrice: average,
  };
}
